/*eslint-disable */
export default {
  name: 'ai-landing-page',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


